export default "__VITE_ASSET__B9o$1NlR__"